import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';
import {
  callNoResponse,
  CallNo,
  locationCollectionResponse,
  Keywords,
} from 'src/app/models/walai';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { AdminService } from 'src/app/services/admin.service';
import { catchError, switchMap } from 'rxjs/operators';
import { Subscription, of } from 'rxjs';
import { ConfigService } from 'src/app/services/config.service';
import { SsoService } from 'src/app/services/sso.service';
import { LocationList } from 'src/app/models/walai';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  locationList: LocationList[];
  langs: any[];
  materialTypes: any[];
  callNoLC: CallNo[];
  callNoDC: CallNo[];
  callNoLocal: CallNo[];
  listBib: any = [];
  bibStr: any = '';
  locationCollectionResponse: locationCollectionResponse[];

  callNoType: string = '';
  qsearchForm: UntypedFormGroup;
  locationNameMain: string;
  locationIDMain: string;
  currentUser: any[] = [];
  brandheading: string;
  isAdmin: string = '0';
  moreLang: boolean = false;
  keyword: Keywords;
  Qkeyword: string;
  CurrentLang: string = 'th';
  MemberImg = '';
  logo = 'assets/images/logo_default.png';
  isLogoLoading: boolean = true;
  // translate: TranslateService;

  logoSubcription: Subscription = new Subscription();
  ngOnDestroy(): void {
    if (this.logoSubcription) {
      this.logoSubcription.unsubscribe();
    }
  }

  constructor(
    private homeService: HomeService,
    private route: Router,
    public translate: TranslateService,
    private data: DataService,
    private adminService: AdminService,
    private configService: ConfigService,
    private sso: SsoService
  ) {
    this.logoSubcription = this.adminService.getLogoBannerPipe('logo')
      .pipe(
        switchMap(async (res: any) => {
          switch (res.status) {
            case 200:
              this.logo = res.body
              break;
            default:
          }
          this.isLogoLoading = false;
        }),
        catchError((e) => {
          this.isLogoLoading = false;
          return of([]);
        })
      )
      .subscribe();

    if (localStorage.getItem('listBib') != null) {
      this.bibStr = localStorage.getItem('listBib');
      var splitted = this.bibStr.split(',');
      splitted.forEach((element: any) => {
        if (element != '') {
          this.listBib.push(element);
        }
      });
    }
    this.data.updateUserData(this.listBib);
    this.data.currentBibList.subscribe(
      (countHold) => (this.listBib = countHold)
    );


    if (this.configService.defaultLanguage != '') {
      this.translate.setDefaultLang(this.configService.defaultLanguage);
      this.translate.use(this.configService.defaultLanguage);
      this.CurrentLang = this.configService.defaultLanguage;
    } else {
      this.translate.use('th');
      this.CurrentLang = 'th';
    }

    if (localStorage.getItem('locationCollectionResponse') != null) {
      this.locationCollectionResponse = JSON.parse(localStorage.getItem('locationCollectionResponse'));
    }
  }

  changeLanguage(lang: string) {
    this.translate.use(lang);
    this.CurrentLang = lang;
    localStorage.setItem('lang', lang);
  }
  export() {
    this.route.navigate(['export']);
  }
  ngOnInit(): void {
    this.data.currentlogo.subscribe((logo) => {
      this.logo = logo;
      if (logo) {
        this.isLogoLoading = false;
      }
    });

    this.data.currentMemberImg.subscribe((data) => (this.MemberImg = data));
    this.data.currentMemberAccountg.subscribe((user) => {
      this.currentUser = user;
      if (user && user.length > 0) {
        this.isAdmin = user[0].ADMINFLAG;
        this.MemberImg = user[0].PATHPIC;
      } else {
        this.isAdmin = '';
      }
    });

    const stored = JSON.parse(localStorage.getItem('WALAIcurrentUser')) || [];
    if (stored.length > 0) {
      this.currentUser = stored;
      this.isAdmin = stored[0].ADMINFLAG;
      this.MemberImg = stored[0].PATHPIC;
    }

    this.brandheading = '';
    this.homeService.getParameter('brandheadingEN').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        this.brandheading = VALUE[0].VALUE;
      }
    });

    // this.currentUser=JSON.parse(localStorage.getItem('WALAIcurrentUser'));;
    // alert(  this.currentUser[0].USERID);
    // Fetch

    if (localStorage.getItem('locationIDMain')) {
      this.locationNameMain = localStorage.getItem('locationNameMain');
      this.locationIDMain = localStorage.getItem('locationIDMain');
    } else {
      if (localStorage.getItem('locationIDMain') == '') {
        this.locationNameMain = 'All location';
        this.locationIDMain = '';
        localStorage.setItem('locationNameMain', 'All location');
        localStorage.setItem('locationIDMain', '');
      } else {
        if (this.configService.defaultLocationID != '') {
          //กรณีที่ห้องสมุดมีหลายสาขาและต้องการให้มีค่าตั้งต้นเป็นสาขาที่ต้องการ
          localStorage.setItem('locationNameMain', this.configService.defaultLocationName);
          localStorage.setItem('locationIDMain', this.configService.defaultLocationID);
          this.locationNameMain = localStorage.getItem('locationNameMain');
          this.locationIDMain = localStorage.getItem('locationIDMain');
        }
      }
    }

    this.getLocation();

    this.browse();

    this.qsearchForm = new UntypedFormGroup({
      textSearch: new UntypedFormControl(),
    });
  }

  getLocation() {
    this.homeService.getLocation().subscribe((location: any) => {


      // ตรวจสอบก่อนว่าใน location มี column active ไหม  ถ้าไม่มีให้เอาทุกอัน แต่ถ้ามีให้กรองเฉพาะ active = true
      if (location[0].hasOwnProperty('active')) {
        this.locationList = location.filter((l: LocationList) => l.active);
      } else {
        this.locationList = location;
      }



      // ให้เรียงตามชื่อ Location A -Z และกำหนด active ให้กับ Location ที่ตรงกับ locationNameMain
      this.locationList = this.locationList.sort((a: LocationList, b: LocationList) => {
        if (a.LOCATIONNAME < b.LOCATIONNAME) {
          return -1;
        }
        if (a.LOCATIONNAME > b.LOCATIONNAME) {
          return 1;
        }
        return 0;
      });

      // Check if location list has only 1 item
      if (this.locationList.length === 1) {
        this.locationNameMain = this.locationList[0].LOCATIONNAME;
        this.locationIDMain = String(this.locationList[0].LOCATIONID);
        localStorage.setItem('locationNameMain', this.locationNameMain);
        localStorage.setItem('locationIDMain', this.locationIDMain);
      } else {
        // Only set default to 'All' if not already set
        if (
          localStorage.getItem('locationNameMain') === null ||
          localStorage.getItem('locationNameMain') === ''
        ) {
          this.locationNameMain = 'All location';
          this.locationIDMain = '';
          localStorage.setItem('locationNameMain', 'All location');
          localStorage.setItem('locationIDMain', '');
        }
      }

      this.locationList.forEach((l: LocationList) => {
        // กำหนด active ให้กับ Location ที่ตรงกับ locationNameMain
        if (l.LOCATIONNAME === this.locationNameMain) {
          l.active = true;
        } else {
          l.active = false;
        }
      });
    });
  }

  ChangeLocation(id, name) {
    this.locationNameMain = name;
    this.locationIDMain = id;

    // Store
    localStorage.setItem('locationNameMain', name);
    localStorage.setItem('locationIDMain', id);
    window.location.reload();
  }

  SiginOut() {
    this.currentUser = [];
    localStorage.setItem('WALAIcurrentUser', JSON.stringify(this.currentUser));
    this.data.updateMemberAccount(this.currentUser);

    switch (this.configService.siteName) {
      case 'KKU':
        // กรณีที่ใช้ SSO ของ KKU
        window.location.href = this.sso.getKKULoginLogOutUrl(false);
        break;
      case 'KMITL':
        // กรณีที่ใช้ SSO ของ KMITL
        window.location.href = this.sso.getKMITLLoginLogOutUrl(false);
        break;
      case 'YRU':
        // กรณีที่ใช้ SSO ของ YRU
        window.location.href = this.sso.getYRULoginLogOutUrl(false, window.location.href);
        break;
      default:
        this.route.navigateByUrl('');
    }

  }

  browse() {
    this.getLang();
    this.getMaterialTypes();
    this.getCallNumber();
    this.getCollection();
  }

  getLang() {
    this.homeService.getLang().subscribe((langs: any) => {
      this.langs = langs;
    });
  }

  getMaterialTypes() {
    this.homeService.getMaterialType().subscribe((getMaterialType: any) => {
      this.materialTypes = getMaterialType;
    });
  }

  showMore() {
    this.moreLang = true;
  }
  showLess() {
    this.moreLang = false;
  }

  getCallNumber() {
    this.homeService
      .getCallNumber()
      .subscribe((callNoResponse: callNoResponse) => {
        this.callNoDC = callNoResponse.callNoDC;
        this.callNoLC = callNoResponse.callNoLC;
        this.callNoLocal = callNoResponse.callNoLocal;
        this.callNoType = callNoResponse.type;
      });
  }

  getCollection() {
    this.homeService
      .getCollection()
      .subscribe((locationCollectionResponse: locationCollectionResponse[]) => {
        this.locationCollectionResponse = locationCollectionResponse;
        localStorage.setItem('locationCollectionResponse', JSON.stringify(locationCollectionResponse));
      });
  }

  // สืบค้นแบบเร่งด้าน ในที่นี้คือการสืบค้นแบบ All key หรือทุกประเภท (มีการตั้งค่าไว้ใน Solr ว่า All ในที่นี่คือ Tag อะไรบ้าง)
  search() {
    if (
      this.qsearchForm.controls.textSearch.value != '' &&
      this.qsearchForm.controls.textSearch.value != null
    ) {
      this.EnterSearch(encodeURIComponent(this.qsearchForm.controls.textSearch.value));
    }
  }

  EnterSearch(keyWord: string) {
    if (this.locationIDMain != '') {
      // กรณีมีการระบุสาขา ซึ่งถ้าเป็นค่าว่าง จะไม่ระบุสาขา
      this.Qkeyword =
        'results?Ntk=KEYWORD|LOCATION&Ntt=' +
        keyWord +
        '|' +
        this.locationIDMain;
    } else {
      this.Qkeyword = 'results?Ntk=KEYWORD&Ntt=' + keyWord;
    }
    window.location.href = this.Qkeyword;
  }

}
